var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStatsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_876:2683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.45543 10.8895C9.62247 11.0565 9.50388 11.3408 9.268 11.3408H1.32332C1.17669 11.3408 1.05939 11.2222 1.05939 11.0769V3.1322C1.05939 2.89632 1.34372 2.77903 1.51074 2.94478L9.45543 10.8895Z",
    fill: "#01C853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.36998 0.531137C2.57399 0.585977 2.64157 0.840981 2.4924 0.990147L2.10479 1.37776L11.8498 11.1228C12.05 11.323 12.05 11.6494 11.8498 11.8495C11.7491 11.9503 11.6178 12 11.4864 12C11.3551 12 11.2238 11.9503 11.123 11.8495L1.37801 2.10453L0.990406 2.49214C0.84124 2.64131 0.586235 2.57245 0.531396 2.36971L0.0124731 0.431672C-0.0563784 0.176667 0.176939 -0.0566492 0.431944 0.0122147L2.36998 0.531137Z",
    fill: "#01C853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_876:2683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(0 -1 -1 0 12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatsUp);
export default __webpack_public_path__ + "static/media/icon-stats-up.7f6257c0.svg";
export { ForwardRef as ReactComponent };